module.exports = __webpack_public_path__ + "img/product_33.51a8a15.webp";